import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { ReactElement, useEffect } from "react";
import ImageUpload from "../components/ImageUpload";
import { useVi } from "../contexts/ViContext";

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: "flex",
    flexFlow: "column",
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    "&::before": {
      content: "''",
      flexGrow: 1,
    },
    "&::after": {
      content: "''",
      flexGrow: 2,
    },
  },
  container: {
    width: "61.8%",
    height: "61.8%",
    margin: "auto",
    boxSizing: "border-box",
  },
}));

function Home({ title }: { title?: string }): ReactElement {
  const classes = useStyles();
  const { onImageLoad } = useVi();

  useEffect(() => {
    document.title = title || "VI Core";
  }, [title]);

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <ImageUpload dropZone {...{ onImageLoad }} />
      </div>
    </div>
  );
}

export default Home;
